import clsx from "clsx";
import { ComponentPropsWithoutRef, ElementType, forwardRef } from "react";
import * as styles from "./ButtonIcon.css";
import DrawnCircle from "~/assets/svgs/DrawnCircle";
import Icon from "./Icon";
import { soundButtonActive } from "~/lib/hooks/sounds/soundButtonActive";
import { soundButtonDisabled } from "~/lib/hooks/sounds/soundButtonDisabled";

export type ButtonIconProps = {
  hasBackground?: boolean;
  icons?: {
    iconPrimary: ElementType;
    iconSecondary?: ElementType;
  };
  iconMotion?: boolean;
  iconSize?: "default" | "large";
} & ComponentPropsWithoutRef<"button"> &
  styles.ThemeVariants;

export const ButtonIcon = forwardRef<HTMLButtonElement, ButtonIconProps>(
  (
    {
      className,
      children,
      theme = "light",
      hasBackground = false,
      icons,
      disabled = false,
      active = false,
      size = "default",
      iconSize = "default",
      iconMotion = false,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <button
        type={"button"}
        ref={ref}
        onClick={(e) => (
          disabled ? soundButtonDisabled() : soundButtonActive(),
          onClick && onClick(e)
        )}
        // disabled={disabled}
        className={clsx(
          className,
          styles.button({
            theme: theme,
            disabled: disabled,
            hasBackground: hasBackground,
            active: active,
            size: size,
          })
        )}
        {...props}
      >
        <ButtonIconContent
          hasBackground={hasBackground}
          active={active}
          children={children}
          icons={icons}
          size={size}
          iconSize={iconSize}
          iconMotion={iconMotion}
        />
      </button>
    );
  }
);

export const ButtonIconContent = ({ ...props }: ButtonIconProps) => {
  const { hasBackground, active, children, icons, size, iconSize, iconMotion } =
    props;
  return (
    <>
      {hasBackground && (
        <DrawnCircle className={styles.circle({ active: active })} />
      )}
      <div className={styles.child}>
        {children ? (
          <>{children}</>
        ) : (
          <>
            {icons && (
              <div
                className={styles.iconContainer({
                  size:
                    size === "Xxl" || iconSize == "large" ? "Xxl" : "default",
                })}
              >
                <div className={styles.icons({ showMotion: iconMotion })}>
                  <Icon
                    svg={icons.iconPrimary}
                    size={
                      size === "Xxl" || iconSize == "large" ? "24px" : "15px"
                    }
                    className={styles.icon({
                      display: iconMotion ? "showOnBoth" : "hideOnActive",
                    })}
                  />
                  <Icon
                    svg={
                      icons.iconSecondary
                        ? icons.iconSecondary
                        : icons.iconPrimary
                    }
                    size={
                      size === "Xxl" || iconSize == "large" ? "24px" : "15px"
                    }
                    className={styles.icon({
                      display: iconMotion ? "showOnBoth" : "showOnActive",
                    })}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
